import {FatcaCrsDeclarationStatus} from '@sollapay/enums';

export const isFatcaCrsDeclarationSigned = (
  status: FatcaCrsDeclarationStatus | undefined
): boolean =>
  status === FatcaCrsDeclarationStatus.SIGNED || status === FatcaCrsDeclarationStatus.COMPLETED;

/** Whose words the signature confirmation is written in. */
export type DeclarationSigner = 'trustee' | 'onBehalf' | 'guest';

export const getDeclarationSigner = ({
  isTrustee,
  isGuest
}: {
  isTrustee: boolean;
  isGuest: boolean;
}): DeclarationSigner => {
  if (isGuest) return 'guest';
  return isTrustee ? 'trustee' : 'onBehalf';
};
